import { writeFile, write, utils } from 'xlsx';
const getColumnWidths = data => {
  const colWidths = {};
  if (data.length > 0) {
    Object.keys(data[0]).forEach(key => {
      colWidths[key] = key.length;
    });
  }
  data.forEach(row => {
    Object.keys(row).forEach(key => {
      const value = row[key];
      const length = value ? value.toString().length : 10; // Default to 10 if no value
      colWidths[key] = Math.max(colWidths[key], length);
    });
  });
  return Object.values(colWidths).map(width => ({
    wch: width
  }));
};
const processCSVData = csvString => {
  // Parse CSV data to worksheet
  const worksheet = utils.csv_to_sheet(csvString);

  // Calculate column widths
  const rows = csvString.split('\n');
  const headers = rows[0].split(',');
  let columnWidths;

  // Create a mock JSON object to calculate column widths
  if (rows.length > 1) {
    const mockJsonData = [];
    for (let i = 1; i < rows.length; i++) {
      if (rows[i].trim()) {
        const values = rows[i].split(',');
        const rowObject = {};
        headers.forEach((header, index) => {
          rowObject[header] = values[index] || '';
        });
        mockJsonData.push(rowObject);
      }
    }
    columnWidths = getColumnWidths(mockJsonData);
  } else {
    // If there's only headers, set a default width
    columnWidths = headers.map(() => ({
      wch: 10
    }));
  }
  return {
    worksheet,
    columnWidths
  };
};
export const exportToExcel = _ref => {
  let {
    data,
    fileName
  } = _ref;
  if (!(data !== null && data !== void 0 && data.length)) return Promise.reject({
    error: 'NoData'
  });
  return new Promise(resolve => {
    const workbook = utils.book_new();
    const worksheet = utils.json_to_sheet(data);
    const columnWidths = getColumnWidths(data);
    worksheet['!cols'] = columnWidths;

    // Sheet name can't exceed 31 characters
    const sheetName = fileName && fileName.length < 31 ? fileName : 'Sheet 1';
    utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, `${fileName}.xlsx`);
    resolve();
  });
};
export const generateExcelFiles = data => {
  if (!(data !== null && data !== void 0 && data.length)) return null;
  const excelFiles = [];
  data.forEach(current => {
    const workbook = utils.book_new();
    let worksheet;
    let columnWidths;

    // Check if the data is CSV format (string) or JSON
    if (typeof current.data === 'string') {
      // Process CSV data using the extracted function
      const csvResult = processCSVData(current.data);
      worksheet = csvResult.worksheet;
      columnWidths = csvResult.columnWidths;
    } else {
      // Process JSON data (original logic)
      worksheet = utils.json_to_sheet(current.data);
      columnWidths = getColumnWidths(current.data);
    }
    worksheet['!cols'] = columnWidths;

    // Sheet name can't exceed 31 characters
    const sheetName = current.name && current.name.length < 31 ? current.name : 'Sheet 1';
    utils.book_append_sheet(workbook, worksheet, sheetName);
    const wbout = write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    excelFiles.push({
      id: current.id,
      data: new Blob([wbout], {
        type: 'application/octet-stream'
      }),
      name: `${current.name}.xlsx`
    });
  });
  return excelFiles;
};